/*
 * 信审工单管理
 *
 * *
 * */
import { ticketClient, client } from "@/api/index";
import { GetVerifyTicketListParamReq, GetVerifyTicketListReq, BatchAssignTicketReq, CloseTicketReq, GetVerifyTicketHandleTimeReq, GetUserTicketLoadReq } from "@/pbjs/xcommon/ticket_pb";
import {
    SearchUserReq,
    BatchGetLoginInfoReq
} from "@/pbjs/external/user/user_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
import ar from "@/assets/i18n/langs/ar";

export interface Options {
    Page: Page;
    ticketid: number, //Ticket ID
    planid: number, //借款 ID
    loanValue: number, //首复贷
    orderstatus: string, //工单状态
    auditresult: number, //审核结果
    ordertype: number, //工单类型
    createtime: string,
    completetime: string,
    closetime: string,
    assigntime: string,
    staffid: number, // 员工ID
    auditor: string, //审核员
    appname: string,
    mobile: number
}
export interface allocationOptions {
    Page: Page;
    ticketid: number, //Ticket ID
    ordertype: number, //工单类型
    staffid: number, // 员工ID
}
export interface userOptions {
    Page: Page;
    name: string,
    email: string,
    role: string,
    UserGroup: string,
    ExecType: number | null,
    IsAttendance: number | null,
    WorkStatus: number | null
}

export interface handletimeOptions {
    itemid: number, //工单类型
    orderid: number, //借款id
    ticketid: number, // Ticket ID
}
//  获取信审工单列表参数 GetVerifyTicketListParamReq
export function getVerifyTicketListParamReq() {
    let request: any = new GetVerifyTicketListParamReq();
    return request;
}
export const getVerifyTicketListParamRequest = new InnerRequest(
    ticketClient,
    ticketClient.getVerifyTicketListParam
);
// 获取信审工单列表 GetVerifyTicketListReq
export function getVerifyTicketListReq(arg: Options) {
    let request: any = new GetVerifyTicketListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setItemid(arg.ordertype); //工单类型
    request.setTicketid(arg.ticketid); //Ticketid
    request.setOrderid(arg.planid);//借款id
    request.setCreatetimerange(arg.createtime);
    request.setCompletetimerange(arg.completetime);
    request.setClosetimerange(arg.closetime);
    request.setAssigntimerange(arg.assigntime);
    request.setStatus(arg.orderstatus); //工单状态
    request.setAssignname(arg.auditor); //审核员
    request.setAssignuid(arg.staffid); //员工ID
    request.setIsreloan(arg.loanValue); //首付贷选项，0：不选，1：复贷，2：首贷
    request.setVerifyresult(arg.auditresult); //审核结果选项
    request.setAppname(arg.appname);
    request.setMobile(arg.mobile)
    return request;
}
export const getVerifyTicketListRequest = new InnerRequest(
    ticketClient,
    ticketClient.getVerifyTicketList
);

// 批量分配工单 BatchAssignTicketReq
export function batchAssignTicketReq(arg: allocationOptions) {
    let arrmin:any =arg.ticketid
    const arr = arrmin.map((item:any)=>{
        return "" + item
      }) // 转换类型为string array
    let request: any = new BatchAssignTicketReq();
    request.setItemid(arg.ordertype); //工单类型
    request.setAssignuid(arg.staffid);  //员工ID
    request.setTicketidsList(arr); // Ticketid arg.ticketid
    return request;
}
export const batchAssignTicketRequest = new InnerRequest(
    ticketClient,
    ticketClient.batchAssignTicket
);
// 搜索用户 SearchUserReq
export function searchUserReq(arg: userOptions) {
    let request: any = new SearchUserReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setName(arg.name);
    request.setEmail(arg.email);
    request.setUsergroup(arg.role);
    request.setExectype(arg.ExecType);
    request.setUsergroup(arg.UserGroup);
    request.setIsattendance(arg.IsAttendance);
    request.setWorkstatus(arg.WorkStatus);
    return request;
}
export const searchUserRequest = new InnerRequest(
    client,
    client.searchUser
);
// 关闭
export function closeTicketReq(arg: allocationOptions) {
    let request: any = new CloseTicketReq();
    request.setTicketid(Number(arg.ticketid));
    request.setItemid(Number(arg.ordertype));
    return request;
}
export const closeTicketRequest = new InnerRequest(
    ticketClient,
    ticketClient.closeTicket
);

// 获取信审工单处理时间
export function getVerifyTicketHandleTimeReq(arg: handletimeOptions) {
    let request: any = new GetVerifyTicketHandleTimeReq();
    request.setItemid(Number(arg.itemid));
    request.setTicketid(Number(arg.ticketid));
    request.setOrderid(Number(arg.orderid))
    return request;
}
export const getVerifyTicketHandleTimeRequest = new InnerRequest(
    ticketClient,
    ticketClient.getVerifyTicketHandleTime
);
// 获取用户负载
export function getUserLoadReq(arg: any) {
    let request: any = new GetUserTicketLoadReq();
    request.setUseridsList(arg.UseridsList);
    request.setTicketitemid(arg.Ticketitemid)
    return request;
}
export const getUserLoadRequest = new InnerRequest(
    ticketClient,
    ticketClient.getUserLoad
);
